import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { ImageAsset } from "../../../sanity/lib/types/imageAsset";
import { ScrollTrigger } from "gsap/all";
import { useRef } from "react";
import { ImageElement } from "../Image";

gsap.registerPlugin(ScrollTrigger);

export const ImageCollage = ({ images }: { images: Array<ImageAsset> }) => {
    const containerRef = useRef<HTMLDivElement>(null);

    useGSAP(
        () => {
            gsap.fromTo(
                ".image:not(:first-child)",
                {
                    y: "100%",
                    transformOrigin: "bottom center",
                },
                {
                    y: 0,
                    stagger: {
                        each: 0.5,
                    },
                    scrollTrigger: {
                        pin: ".images",
                        scrub: true,
                        start: "center 50%",
                        end: "bottom top",
                        invalidateOnRefresh: true,
                    },
                },
            );
        },

        { scope: containerRef },
    );

    return (
        <div className="container relative" ref={containerRef}>
            <div className="mx-2.5 md:mx-5">
                <div className={`relative w-full max-h-dvh images overflow-hidden`}>
                    {images.map(
                        (image, index) =>
                            image.image?.asset?._ref && (
                                <ImageElement
                                    key={index}
                                    width={2560}
                                    src={image.image}
                                    alt={image.alt || ""}
                                    className={`absolute max-h-dvh image top-0 left-0 w-full h-auto object-cover aspect-[1400/932] ${index === 0 && "relative"}`}
                                />
                            ),
                    )}
                </div>
            </div>
        </div>
    );
};
